import comp0 from '@/app/cookieconsent'
import comp1 from '@/app/sentry'
import comp2 from '@/app/youtube'
import comp3 from '@/app/carousel'
import comp4 from '@/app/collapsible'
import comp5 from '@/app/beerslider'
import comp6 from '@/app/products'
import comp7 from '@/app/searchReq'
import comp8 from '@/app/co2calculator'
import comp9 from '@/app/overlaytoggle'
import comp10 from '@/app/filter-downloads'
import comp11 from '@/app/askabout'
import comp12 from '@/app/galleryoverlay'
import comp13 from '@/app/numbersreel'
import comp14 from '@/app/productdetail'
import comp15 from '@/app/scrollspy'
import comp16 from '@/app/tempColCount'
import comp17 from '@/app/filter-news'
import comp18 from '@/app/active'
import comp19 from '@/app/autoheight'
import comp20 from '@/app/showMoreImages'
import comp21 from '@/app/header'
import comp22 from '@/app/navigation'
import comp23 from '@/app/button-style'
import comp24 from '@/app/contactselect'
import comp25 from '@/app/zipSearch'
import comp26 from '@/app/logger'
import comp27 from '@/app/collapsible-previewed'
import comp28 from '@/app/coolingfilter'
import comp29 from '@/app/historticRedirect'
import comp30 from '@/app/teamlist'
var map={}; 
map['app/cookieconsent']=comp0;
map['app/sentry']=comp1;
map['app/youtube']=comp2;
map['app/carousel']=comp3;
map['app/collapsible']=comp4;
map['app/beerslider']=comp5;
map['app/products']=comp6;
map['app/searchReq']=comp7;
map['app/co2calculator']=comp8;
map['app/overlaytoggle']=comp9;
map['app/filter-downloads']=comp10;
map['app/askabout']=comp11;
map['app/galleryoverlay']=comp12;
map['app/numbersreel']=comp13;
map['app/productdetail']=comp14;
map['app/scrollspy']=comp15;
map['app/tempColCount']=comp16;
map['app/filter-news']=comp17;
map['app/active']=comp18;
map['app/autoheight']=comp19;
map['app/showMoreImages']=comp20;
map['app/header']=comp21;
map['app/navigation']=comp22;
map['app/button-style']=comp23;
map['app/contactselect']=comp24;
map['app/zipSearch']=comp25;
map['app/logger']=comp26;
map['app/collapsible-previewed']=comp27;
map['app/coolingfilter']=comp28;
map['app/historticRedirect']=comp29;
map['app/teamlist']=comp30;
export default map;